export class ApiPaths {

    public static myProjects = {
       getProjectsList: 'projects/get-project-list',
       getProjectTypes: 'project-types/list',
       getServiceLines: 'services/get-service-line',
       getBidDetails: 'projects/get-project-bid-list',
       createProject: 'projects/create-project',
       getMarketsList: 'searches/findCriteriaBySearch',
       saveProject: 'projects',
       getSelectedProviderInfo: 'searches/findCriteriaBySearch',
       deleteProject: 'projects/delete-project/',
       getProjectDetails: 'projects/get-project-details',
       getBidChatHistory: 'project-bid-messages/get-list',
       cancelBid: 'projects/cancel-project-request',
       acceptBid: 'projects/accept-project-bid',
       launchProject: 'projects/update-project-status',
       getTaskList: 'project-task-mappings/get-task/',
       getAvailableTask: `/project-task-mappings/get-available-tasks`,
       getDependentTaskList: 'project-task-mappings/get-dependee-task-list',
       createTask: 'project-task-mappings/create-project-task',
       dependeeTaskList: 'project-task-mappings/get-dependee-task-list',
       getDocumentsList: 'project-documents/get-list',
       createBidMessage: 'project-bid-messages/create-project-bid-message',
       deleteDocument: 'projects/delete-document',
       uploadDocument: 'amazon-storages/',
       createProjectDocument: 'project-documents/create-project-document',
       taskDetails: 'projects/task-details',
       getTaskAssigneeList: 'projects/getTaskAssigneeList',
       getUpdatesList: 'projects/updates',
       getTaskCommentsList: 'Comments/list',
       postTaskComment: 'projects/comment',
       getTaskAttachments: 'projects/task/attachments',
       deleteTaskDocument: 'projects/task/attachments/delete',
       deleteTask: 'projects/task/delete',
       submitBid: 'projects/submit-project-bid',
       rejectBid: 'projects/bid/reject',
       taskAssigneeList: 'project-task-mappings/get-assigned-task-user-list',
       updateTaskStatus: 'project-task-mappings/edit-status',
       projectPayment: 'payments/project-payment',
       getPrice: 'stripe-checkouts/get-price-key',
       projectTokenDetails: `/payments/get-project-price-details`,
       projectGroupCall: `/message-groups/create-project-group`,
       postDependentTask: `/project-task-mappings/add-dependent-task-ids`,
       getAttachmentList : `/project-documents/get-list`,
       projectUpdate : `projects/updates-list`,
       updateTask : `/project-task-mappings/update-project-task-details`,
       deleteUploadDoc : `/amazon-storages/document-delete`,
       declineBid: `/projects/change-project-request-status`,
       getProjectCount: `/projects/get-project-count`,
       deletePendingProject : `/projects/delete-pending-projects`,
       editProject : `/projects/update-pending-projects`,
       reorderTask : `/project-task-mappings/reorder-tasks`,
       editTask : `/projects/update-task`,
       approveMilestone : `/projects/confirm-milestone-task`,
       deletePending: `/projects/delete-task`,
      clientDetails: `/users/client-search`,
      };

    public static likesComments = {
      getCommentsList: 'Comments/list',
      postComment : 'Comments',
      getMentionableUsers: 'users/mentionable-users',
    };
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/api-path.ts